<template>
  <div id="card">
    <div v-if="wine.typology === 1">
      <div v-if="checkAvailability(wine.available, wine.qntyProd)" class="vino"><img
          :src="'static/image/products/'+wine.image+'Shop.png'" class="immagine">
        <div class="row">
          <div class="col-lg-12 nomeVino">{{wine.nome}}</div>
          <div class="col-lg-12 desc" v-html="wine.descr"></div>
          <!--<div class="col-lg-6 col-sm-6 col-md-6 col-6 price" v-price>{{wine.price}}</div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                                  min="1" :max="wine.qntyProd" class="quantità"
                                                                                  id="qua"
                                                                                  oninput="validity.valid||(value=1)"
                                                                                  v-model="qntyOrd"
                                                                                  v-validate="'required'">
          </div>-->
          <div class="col-lg-12 scheda" style="text-align: center;margin-top: 5px">
            <router-link :to="{name: 'schedavini', params: {id: wine.id, language: wine.language}}">Vai alla scheda</router-link>
          </div>
          <!--<b-btn class="bottone" @click="addToCart">Aggiungi al carrello</b-btn>-->
          <div style="text-align:center;width:100%">
          <!--HubSpot Call-to-Action Code -->
<!--            <span class="hs-cta-wrapper" id="hs-cta-wrapper-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0">-->
<!--              <span class="hs-cta-node hs-cta-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0" id="hs-cta-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0">&lt;!&ndash;[if lte IE 8]>-->
<!--                <div id="hs-cta-ie-element">-->
<!--                </div><![endif]&ndash;&gt;<a href="https://cta-redirect.hubspot.com/cta/redirect/5864348/86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0"  target="_blank" >-->
<!--                <img class="hs-cta-img" id="hs-cta-img-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0" style="border-width:0px;" src="https://no-cache.hubspot.com/cta/default/5864348/86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0.png"  alt="VISITA LO SHOP ONLINE"/>-->
<!--              </a></span></span>&lt;!&ndash; end HubSpot Call-to-Action Code &ndash;&gt;-->
          </div>
          </div>
      </div>
      <div v-else class="notvino">
        <router-link :to="{name: 'schedavini', params: {id: wine.id, language: wine.language}}"><img
          :src="'static/image/products/'+wine.image+'Shop.png'" class="notimmagine"></router-link>
        <div class="row" style="text-align: center">
          <div class="col-lg-12 nomeVino">{{wine.nome}}</div>
          <div class="col-lg-12 desc" v-html="wine.descr"></div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 price" v-price>{{wine.price}}</div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                                  min="1" :max="wine.qntyProd" class="quantità"
                                                                                  id="qua"
                                                                                  oninput="validity.valid||(value=1)"
                                                                                  v-model="qntyOrd"
                                                                                  v-validate="'required'">
          </div>
          <div class="col-lg-12 scheda">
            <router-link :to="{name: 'schedavini', params: {id: wine.id, language: wine.language}}">Scheda</router-link>
          </div>
          <div class="notbottone col-xl-12">Attualmente non disponibile</div>
        </div>
      </div>
    </div>
    <div v-if="wine.typology === 2">
      <div v-if="checkAvailability(wine.available, wine.qntyProd)" class="vino">
        <router-link :to="{name: 'smartbox', params: {id: wine.id, language: wine.language}}"><img
          :src="'static/image/products/'+wine.image" class="immagineSmartbox"></router-link>
        <div class="row">
          <div class="col-lg-12 nomeSmartbox">{{wine.nome}}</div>
          <div class="col-lg-12 descSmartbox" v-html="cleanText(wine.descr)"></div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 price" v-price>{{wine.price}}</div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                                  min="1" :max="wine.qntyProd" class="quantità"
                                                                                  id="qua"
                                                                                  oninput="validity.valid||(value=1)"
                                                                                  v-model="qntyOrd"
                                                                                  v-validate="'required'">
          </div>
          <div class="col-lg-12 scheda">
            <router-link :to="{name: 'smartbox', params: {id: wine.id, language: wine.language}}">Scheda</router-link>
          </div>
<!--          <b-btn class="bottone" @click="addToCart">Aggiungi al carrello</b-btn>-->
        </div>
      </div>
      <div v-else class="notvino">
        <router-link :to="{name: 'smartbox', params: {id: wine.id, language: wine.language}}"><img
          :src="'static/image/products/'+wine.image" class="notimmagineSmartbox"></router-link>
        <div class="row">
          <div class="col-lg-12 nomeSmartbox">{{wine.nome}}</div>
          <div class="col-lg-12 descSmartbox" v-html="cleanText(wine.descr)"></div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 price" v-price>{{wine.price}}</div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                                  min="1" :max="wine.qntyProd" class="quantità"
                                                                                  id="qua"
                                                                                  oninput="validity.valid||(value=1)"
                                                                                  v-model="qntyOrd"
                                                                                  v-validate="'required'">
          </div>
          <div class="col-lg-12 scheda">
            <router-link :to="{name: 'smartbox', params: {id: wine.id, language: wine.language}}">Scheda</router-link>
          </div>
          <div class="notbottone col-xl-12">Attualmente non disponibile</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from './Bus'
  import moment from 'moment'

  export default {
    name: "card",
    data() {
      return {
        qntyOrd: 1
      }
    },
    computed: {
      subTot: function () {
        return this.wine.qntyOrd * this.wine.price
      }
    },
    props: {
      wine: {type: Object}
    },
    methods: {
      checkAvailability: function (available, qntyProd) {
        let d = new Date();
        if (moment(d).isAfter(available) & qntyProd > 0) {
          return true
        } else return false
      },
      cleanText(text) {
          return text.replace(/[<br>]/g, '');
      },
      addToCart: function () {
        let idCarrello = localStorage.getItem('idCarrello') === null || localStorage.getItem('idCarrello') === undefined ? '0' : localStorage.getItem('idCarrello')
        let data = {
          idCartEncrypted: idCarrello,
          idProduct: this.wine.id,
          qntyOrd: this.qntyOrd
        }
        this.$http.post('/ws-shop/cart/add', data).then(response => {
          if (response.body.idCart) {
            localStorage.setItem('idCarrello', response.body.idCart)
          }
          if (response.body.rc === 0) {
            this.$toasted.show(this.$t('prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'success',
              duration: 4000
            })
            Bus.$emit('totCart')
          } else {
            this.$toasted.show(this.$t('prb_prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          prod_add: 'Prodotto aggiunto al carrello',
          prb_prod_add: 'Errore, inserire quantità'
        },
        en: {
          prod_add: 'Prodotto aggiunto al carrello',
          prb_prod_add: 'Errore, inserire quantità'
        }
      }
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/Card.vue